import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setDisplayLoader, setLanguage } from '@/redux/app/appSlice';
import {
  setUserId,
  setUserCreatedAt,
  setUserEmail,
  setUserLogin,
  setUserFirstName,
  setUserLastName,
  // setUserBirthDate,
  // setUserGender,
  setUserPhone,
  // setUserCountry,
  setUserAvatar,
  setUserGravatar,
  setUserIs2Fa,
  setUserStatus,
  setUserRegistrationDate,
  setUserIsPreferKyc,
} from '@/redux/user/userSlice';

import userService from '@/services/userService';

const getUser = () => async dispatch => {
  try {
    dispatch(setDisplayLoader(true));

    const data = await userService.getUser();

    const {
      id,
      created_at,
      registration_date,
      login,
      email,
      first_name,
      last_name,
      // birth_date, gender, phone, country,
      phone,
      picture_path,
      language,
      status,
      is_2fa_enabled,
      can_use_preferential_kyc,
    } = data;

    dispatch(setUserId(id));
    dispatch(setUserCreatedAt(created_at));
    dispatch(setUserRegistrationDate(registration_date));
    dispatch(setUserLogin(login));
    dispatch(setUserEmail(email));
    dispatch(setUserFirstName(first_name));
    dispatch(setUserLastName(last_name));
    // dispatch(setUserBirthDate(birth_date))
    // dispatch(setUserGender(gender))
    dispatch(setUserPhone(phone));
    // dispatch(setUserCountry({
    //   id: country.country_id,
    //   name: country.name
    // }))
    dispatch(setUserAvatar(picture_path));
    dispatch(
      setUserGravatar(
        `${first_name?.charAt(0)}${last_name ? last_name?.charAt(0) : ''}`,
      ),
    );
    dispatch(
      setLanguage({
        id: language.language_id,
        name: language.name,
        code: language.code,
      }),
    );
    dispatch(setUserStatus(status.name));
    dispatch(setUserIs2Fa(is_2fa_enabled));
    dispatch(setUserIsPreferKyc(can_use_preferential_kyc));
  } catch (e) {
    if (e?.response?.status === 401) return;

    if (e?.response?.status === 429) {
      Notify.failure('Too much requests - try later ...');
      return;
    }

    Notify.failure(e?.response?.data?.message || 'Request GetUser failure');
  } finally {
    dispatch(setDisplayLoader(false));
  }
};

export default {
  getUser,
};
